<template>
  <languages-form
    :language="language"
    @save="save"
    @delete="proxyRemove"
  />
</template>

<script>
import LanguagesForm from '../components/LanguagesForm'
import { mapActions } from 'vuex'

export default {
  name: 'LanguagesNew',
  components: {
    LanguagesForm
  },
  data () {
    return {
      language: {
        code: ''
      }
    }
  },
  created () {
    this.find(this.$route.params.id)
      .then(({ data }) => {
        this.language = data
      })
  },
  methods: {
    ...mapActions('language', [
      'update',
      'find',
      'remove'
    ]),
    save (newLang) {
      this.update(newLang)
    },
    proxyRemove (id) {
      if (confirm('Are you sure you want to delete this language?')) {
        this.remove(id)
          .then(() => {
            this.$router.push('.')
          })
      }
    }
  }
}
</script>
